'use strict';
var $TypeError = TypeError;

module.exports = function (options) {
  var alphabet = options && options.alphabet;
  if (alphabet === undefined || alphabet === 'base64' || alphabet === 'base64url') return alphabet || 'base64';
  throw new $TypeError('Incorrect `alphabet` option');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/get-alphabet-option.js
// module id = 332
// module chunks = 113